export default __webpack_public_path__ + "static/media/indian.2052a668.png";